// ── Modal de inactividad ──────────────────────────────────────
// Se activa tras 10 min sin actividad. Muestra cuenta regresiva
// de 15 seg y redirige a /logout si el usuario no responde.

(function () {

    const TIEMPO_INACTIVIDAD_MS =10 * 60 * 500; // 5 minutos
    const TIEMPO_CUENTA_REGRESIVA = 15;            // segundos
    const URL_LOGOUT = '/logout';

    let temporizadorInactividad = null;
    let temporizadorCuentaRegresiva = null;
    let segundosRestantes = TIEMPO_CUENTA_REGRESIVA;

    // ── Elementos del DOM ────────────────────────────────────
    function obtenerElementos() {
        return {
            modal: document.getElementById('modalInactividad'),
            contador: document.getElementById('contadorInactividad'),
            btnContinuar: document.getElementById('btnContinuarSesion'),
        };
    }

    // ── Mostrar modal ────────────────────────────────────────
    function mostrarModalInactividad() {
        const { modal, contador, btnContinuar } = obtenerElementos();
        if (!modal) return;

        segundosRestantes = TIEMPO_CUENTA_REGRESIVA;
        if (contador) contador.textContent = segundosRestantes;

        modal.classList.add('modal--show');

        temporizadorCuentaRegresiva = setInterval(() => {
            segundosRestantes -= 1;
            if (contador) contador.textContent = segundosRestantes;

            if (segundosRestantes <= 0) {
                clearInterval(temporizadorCuentaRegresiva);
                window.location.href = URL_LOGOUT;
            }
        }, 1000);
    }

    // ── Cerrar modal ─────────────────────────────────────────
    function cerrarModalInactividad() {
        const { modal } = obtenerElementos();
        if (!modal) return;

        clearInterval(temporizadorCuentaRegresiva);
        modal.classList.remove('modal--show');
        reiniciarTemporizador();
    }

    // ── Reiniciar temporizador de inactividad ────────────────
    function reiniciarTemporizador() {
        clearTimeout(temporizadorInactividad);
        temporizadorInactividad = setTimeout(mostrarModalInactividad, TIEMPO_INACTIVIDAD_MS);
    }

    // ── Eventos que reinician la inactividad ─────────────────
    const eventosActividad = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'click'];

    function manejarActividad() {
        const { modal } = obtenerElementos();
        // Solo reiniciar si el modal no está visible
        if (modal && modal.classList.contains('modal--show')) return;
        reiniciarTemporizador();
    }

    // ── Inicialización ───────────────────────────────────────
    function iniciar() {
        const { modal, btnContinuar } = obtenerElementos();
        if (!modal) return;

        // Botón "Continuar sesión"
        if (btnContinuar) {
            btnContinuar.addEventListener('click', cerrarModalInactividad);
        }

        // Escuchar actividad del usuario
        eventosActividad.forEach(evento => {
            document.addEventListener(evento, manejarActividad, { passive: true });
        });

        // Arrancar el primer temporizador
        reiniciarTemporizador();
    }

    document.addEventListener('DOMContentLoaded', iniciar);

})();
